import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(_vm.$route.path != '/' && _vm.$route.name != 'Not found')?_c('TopBar'):_vm._e(),_c('router-view'),_c('SnackBar'),_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }